// extracted by mini-css-extract-plugin
export default {"root":"TranslatePromptModal_root__D05OO","tooltip":"TranslatePromptModal_tooltip__Clj4T","drawer":"TranslatePromptModal_drawer__Skhmm"};